export const MaxSenderIdCount = 5;
